// extracted by mini-css-extract-plugin
module.exports = {"firstRowWithControls":"_3fTfGHZKjBBbjZY62CELq","secondRowWithControls":"_2fhrsl-Js6yYgrqIBQxkL","verticalAlignBlock":"_39aaetZS9RS2tkgUrS4tKh"};